/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
import Swal from "sweetalert2";

import anime from "animejs/lib/anime.es.js";
const forms = document.querySelectorAll(".sc-job-form__content");

let options = {
	root: null,
	rootMargin: "0px",
	threshold: 0.0,
};
function handleFormWatcherEntry(entries, observer) {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			animateForm(entry.target);
			observer.unobserve(entry.target);
		}
	});
}

const intersectionWathcer = () => {
	let observerForm = new IntersectionObserver(handleFormWatcherEntry, options);

	forms.forEach((form) => {
		observerForm.observe(form);
	});
};

intersectionWathcer();

const animateForm = (form) => {
	anime({
		targets: form,
		top: "-40px",
		opacity: [0, 1],
		easing: "easeOutExpo",
		duration: 500,
		delay: 500,
	});
};

const fileUploadButton = document.querySelectorAll(
	".sc-job-form__content__fields__one-column__files",
);
const uploadFile = document.querySelectorAll(
	".sc-job-form__content__fields__one-column__fake-files",
);

const uploadIcon = document.querySelectorAll(".sc-input__paperclip");
uploadIcon[0].addEventListener("click", () => {
	fileUploadButton[0].click();
});
uploadFile[0].addEventListener("click", () => {
	fileUploadButton[0].click();
});
fileUploadButton[0].addEventListener("change", function () {
	var fileMB = fileUploadButton[0].files[0].size / 1048576;

	var allowedExtensions = [
		"jpg",
		"jpeg",
		"png",
		"doc",
		"docx",
		"xls",
		"xlsx",
		"pdf",
		"ppt",
		"pptx",
		"tif",
		"tiff",
	];
	var fileExtension = fileUploadButton[0].files[0].name
		.split(".")
		.pop()
		.toLowerCase();
	if (allowedExtensions.includes(fileExtension)) {
		if (fileMB < 2) {
			uploadFile[0].value = fileUploadButton[0].files[0].name;
			valuesCorrect["files"] = true;
		} else {
			this.value = "";
			uploadFile[0].value = "";
			valuesCorrect["files"] = false;
			Swal.fire({
				icon: "error",
				title: "Por favor prueba de nuevo",
				text: "El archivo subido supera la capacidad permitida",
				confirmButtonColor: "#00369c",
				confirmButtonText: "Esta bien",
			});
		}
	} else {
		this.value = "";
		uploadFile[0].value = "";
		valuesCorrect["files"] = false;
		Swal.fire({
			icon: "error",
			title: "Por favor prueba de nuevo",
			text: "El archivo subido no es valido",
			confirmButtonColor: "#00369c",
			confirmButtonText: "Esta bien",
		});
	}
});

const select = document.getElementById("vacancy-city");

let name = document.getElementById("vacancy-full-name");
let name_error_message = document.getElementById(
	"vacancy-full-name__error-message",
);
let id_number = document.getElementById("vacancy-id-number");
let id_number_error_message = document.getElementById(
	"vacancy-id-number__error-message",
);
let id_type = document.getElementById("vacancy-id-type");

let email = document.getElementById("vacancy-email");
let email_error_message = document.getElementById(
	"vacancy-email__error-message",
);
let location = document.getElementById("vacancy-city");
const department = document.getElementById("vacancy-department");
let phone_code = document.getElementById("sc-phone-input");

let phone_number = document.getElementById("vacancy-phone-number");
let phone_number_error_message = document.getElementById(
	"vacancy-phone-number__error-message",
);
let salary = document.getElementById("vacancy-salary");
let salary_error_message = document.getElementById(
	"vacancy-salary__error-message",
);

let files = document.getElementById("vacancy-files");

const button = document.getElementById("vacancy-submit-button");
let isFormSubmitted = false;
//TODO MIRAR VACANTE

const valuesCorrect = {
	name: false,
	id_number: false,
	email: false,
	phoneNumber: false,
	salary: false,
};
const form = document.getElementById("sc-job-form");
name.addEventListener("input", (event) => {
	name.value = name.value.replace(/[^a-zA-Z ]/gi, "");
	if (event.target.value.length < 3) {
		if (!name.className.includes("sc-input-error")) {
			name.className += " sc-input-error";
			name_error_message.style.display = "inline";
		}
		valuesCorrect["name"] = false;
	} else {
		if (name.className.includes("sc-input-error")) {
			name.className = name.className.replace("sc-input-error", "");
			name_error_message.style.display = "none";
		}
		valuesCorrect["name"] = true;
	}
	activateForm();
});
id_number.addEventListener("input", (event) => {
	if (event.target.value.length < 3) {
		if (!id_number.className.includes("sc-input-error")) {
			id_number.className += " sc-input-error";
			id_number_error_message.style.display = "inline";
		}
		valuesCorrect["id_number"] = false;
	} else {
		if (id_number.className.includes("sc-input-error")) {
			id_number.className = id_number.className.replace("sc-input-error", "");
			id_number_error_message.style.display = "none";
		}
		valuesCorrect["id_number"] = true;
	}
	activateForm();
});
email.addEventListener("input", (event) => {
	const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

	if (!pattern.test(event.target.value)) {
		if (!email.className.includes("sc-input-error")) {
			email.className += " sc-input-error";
			email_error_message.style.display = "inline";
		}
		valuesCorrect["email"] = false;
	} else {
		if (email.className.includes("sc-input-error")) {
			email.className = email.className.replace("sc-input-error", "");
			email_error_message.style.display = "none";
		}
		valuesCorrect["email"] = true;
	}
	activateForm();
});

phone_number.addEventListener("input", (event) => {
	const pattern = /^[+]{1}(?:[0-9\-\\(\\)\\/.]\s?){6,15}[0-9]{1}$/;

	if (!pattern.test(phone_code.value + event.target.value)) {
		if (!phone_number.className.includes("sc-input-error")) {
			phone_number.className += " sc-input-error";
			phone_number_error_message.style.display = "inline";
		}
		valuesCorrect["phoneNumber"] = false;
	} else {
		if (phone_number.className.includes("sc-input-error")) {
			phone_number.className = phone_number.className.replace(
				"sc-input-error",
				"",
			);
			phone_number_error_message.style.display = "none";
		}
		valuesCorrect["phoneNumber"] = true;
	}
	activateForm();
});

salary.addEventListener("input", (event) => {
	let temp = salary.value
		.replaceAll(/[^0-9]/g, "")
		.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
	salary.value = temp;
	if (event.target.value.length < 1) {
		if (!salary.className.includes("sc-input-error")) {
			salary.className += " sc-input-error";
			salary_error_message.style.display = "inline";
		}
		valuesCorrect["salary"] = false;
	} else {
		if (salary.className.includes("sc-input-error")) {
			salary.className = salary.className.replace("sc-input-error", "");
			salary_error_message.style.display = "none";
		}
		valuesCorrect["salary"] = true;
	}
	activateForm();
});
const activateForm = () => {
	let activo = true;
	for (const [key, value] of Object.entries(valuesCorrect)) {
		if (!value) {
			activo = false;
		}
	}

	if (activo) {
		if (button.className.includes("sc-button-disabled")) {
			button.className = button.className.replace(
				"sc-button-disabled",
				"sc-button-primary",
			);
		}

		button.disabled = false;
	} else {
		if (button.className.includes("sc-button-primary"))
			button.className = button.className.replace(
				"sc-button-primary",
				"sc-button-disabled",
			);
		button.disabled = true;
	}
};

form.addEventListener("submit", function (event) {
	event.preventDefault();

	if (!isFormSubmitted) {
		isFormSubmitted = true;
		const formData = new FormData();

		let vacant = document.title.split("-")[0];

		formData.append("full_name", name.value);
		formData.append("id_type", id_type.value);
		formData.append("id_number", id_number.value);
		formData.append("email", email.value);
		formData.append("phone_code", phone_code.value);
		formData.append("phone_number", phone_number.value);
		formData.append("email", email.value);
		formData.append("city", location.value);
		formData.append("department", department.value);
		formData.append("salary", salary.value);
		formData.append("file_attached", files.files[0]);
		formData.append("optim", "true");
		formData.append("ApplicacionEnvia", "SitioWeb");
		formData.append("vacante", vacant);

		if (
			name &&
			id_number &&
			id_type &&
			email &&
			phone_code &&
			phone_number &&
			files &&
			location &&
			salary
		) {
			fetch(`${window.location.origin}/wp-json/sisteforms/v1/vacancy`, {
				method: "POST",
				body: formData,
			})
				.then((result) => {
					return result.json();
				})
				.then((data) => {
					isFormSubmitted = false;
					dataLayer.push({
						event: "Formulario enviado",
						name: `${vacant}`,
					});
					Swal.fire({
						icon: "success",
						title: "Hemos recibido tu mensaje",
						text: "En breve nos comunicaremos contigo",
						confirmButtonColor: "#00369c",
						confirmButtonText: "Esta bien",
					}).then((result) => {
						window.location.reload();
					});
				})
				.catch((error) => {
					Swal.fire({
						icon: "error",
						title: "No se pudo enviar el mensaje",
						text: "Por favor intenta más tarde",
						confirmButtonColor: "#00369c",
						confirmButtonText: "Esta bien",
					});
				});
		}
	}
});

const añadirLocalizacionAlFiltro = () => {
	const headers = new Headers();
	headers.append("SCOrigen", "Production");
	headers.append("country", "co");
	headers.append("SCLocation", "1,1");
	headers.append(
		"Ocp-Apim-Subscription-Key",
		"c3679e2a448746478daf79df5622ba36;product=SitioWeb"
	);
	fetch("https://api.sistecredito.com/locations/GetStates", {
		method: "GET",
		headers: headers,
	})
		.then((result) => {
			if (result.ok) {
				return result.json();
			}
			throw new Error("Something went wrong");
		})
		.then((data) => {
			data.data.locations.map(function (item) {
				var opcion = document.createElement("option");
				opcion.value = item.name;
				opcion.text = item.name;
				opcion.setAttribute("data-code", item.code);
				department?.appendChild(opcion);
			});
		});
};

department.addEventListener("change", function () {
	select.innerHTML = "<option>Loading...</option>";
	const headers = new Headers();
	headers.append("SCOrigen", "Production");
	headers.append("country", "co");
	headers.append("SCLocation", "1,1");
	headers.append(
		"Ocp-Apim-Subscription-Key",
		"c3679e2a448746478daf79df5622ba36;product=SitioWeb",
	);

	fetch(
		`https://api.sistecredito.com/locations/GetCitiesByStateCode?stateCode=${this.selectedOptions[0].dataset.code}`,
		{
			method: "GET",
			headers: headers,
		},
	)
		.then((result) => {
			if (result.ok) {
				return result.json();
			}
			throw new Error("Something went wrong");
		})
		.then((data) => {
			select.innerHTML = "";

			data.data.locations.map(function (item) {
				var opcion = document.createElement("option");
				opcion.value = item.name;
				opcion.text = item.name;
				opcion.setAttribute("data-code", item.code);
				select?.appendChild(opcion);
			});
		});
});

añadirLocalizacionAlFiltro();

var originalTexts = {};

Array.from(id_type.children).forEach((option) => {
	originalTexts[option.value] = option.textContent;
});

window.onload = function () {
	let flag = true;
	checkhistory();
	Array.from(id_type.options).forEach((option) => {
		if (id_type.defaultvalue === option.value) {
			option.textContent = option.value;
			flag = false;
		}
	});

	if (flag) {
		Array.from(id_type.options)[0].textContent = Array.from(
			id_type.options,
		)[0].value;
	}
};

const checkhistory = () => {
	if (name.value.length < 3) {
		valuesCorrect["name"] = false;
	} else {
		valuesCorrect["name"] = true;
	}
	const pattern = /^[+]{1}(?:[0-9\-\\(\\)\\/.]\s?){6,15}[0-9]{1}$/;

	if (!pattern.test(phone_code.value + phone_number.value)) {
		valuesCorrect["phoneNumber"] = false;
	} else {
		valuesCorrect["phoneNumber"] = true;
	}

	if (id_number.value.length < 3) {
		valuesCorrect["id_number"] = false;
	} else {
		valuesCorrect["id_number"] = true;
	}
	const patternMail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

	if (!patternMail.test(email.value)) {
		valuesCorrect["email"] = false;
	} else {
		valuesCorrect["email"] = true;
	}

	if (salary.value.length < 1) {
		valuesCorrect["salary"] = false;
	} else {
		valuesCorrect["salary"] = true;
	}

	activateForm();
};
id_type.addEventListener("change", (event) => {
	Array.from(id_type.options).forEach((option) => {
		if (option.value === event.target.value) {
			option.textContent = option.value;
		} else {
			option.textContent = originalTexts[option.value];
		}
	});
});

button.addEventListener("click", () => {
	dataLayer.push({
		event: "click",
		name: button.textContent,
		page: window.location.pathname,
		id: button.textContent,
	});
});
